// @flow
import {Component, ErrorInfo, ReactNode} from 'react';
import {reportError} from '../reportEvent';

type Props = {
    onError: (...errorArgs: [Error, ErrorInfo]) => any;
    name: string;
    fallbackUI?: ReactNode;
};

type State = {
    hasError: boolean;
};

export default class ErrorReportBoundary extends Component<Props, State> {
    static getDerivedStateFromError(): State {
        return {hasError: true};
    }
    state = {hasError: false, fallbackUI: null};

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        reportError({
            name: this.props.name,
            componentError: {error, errorInfo}
        });
        this.setState({hasError: true});
        if (typeof this.props.onError === 'function') {
            this.props.onError(error, errorInfo);
        }
    }

    render(): ReactNode | null {
        if (this.state.hasError) {
            return this.props.fallbackUI || null;
        }

        return this.props.children;
    }
}
